import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
const VIDEOS = [{
  title: 'RuslanSilvr - whatever reason',
  views: '',
  image: 'https://cdn.magicpatterns.com/uploads/bx7C2PAmtmoW7CyLa3cbcb/Untitled_design-5.png',
  url: 'https://youtu.be/fh11xaz0oeI?si=jJo31FE3_6XX6akZ'
}, {
  title: 'RuslanSilvr - Lighter',
  views: '',
  image: 'https://img.youtube.com/vi/gH44Rch6C0I/maxresdefault.jpg',
  url: 'https://youtu.be/gH44Rch6C0I?si=Kii9VIHWBP1thCFY'
}, {
  title: 'RuslanSilvr - juk',
  views: '',
  image: 'https://img.youtube.com/vi/VCRWtOgMBHQ/maxresdefault.jpg',
  url: 'https://youtu.be/VCRWtOgMBHQ?si=BlyGnPc0mNIiwpJs'
}];
export function Videos() {
  return <section id="videos" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-99">
      <SectionHeader number="04" title="Visuals" data-id="element-100" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-101">
        {VIDEOS.map((video, i) => {
        const Wrapper: any = video.url ? motion.a : motion.div;
        const linkProps = video.url ? {
          href: video.url,
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {};
        return <Wrapper key={video.title} {...linkProps} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2,
          duration: 0.6
        }} className="group cursor-pointer block focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-4 focus-visible:ring-offset-brand-black" data-id="element-102">
              <div className="relative aspect-video mb-4 overflow-hidden bg-brand-surface" data-id="element-103">
                <img src={video.image} alt={video.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-104" />
                <div className="absolute inset-0 bg-brand-black/20 group-hover:bg-brand-black/40 transition-colors duration-300 flex items-center justify-center" data-id="element-105">
                  <div className="w-16 h-16 rounded-full border-2 border-brand-white flex items-center justify-center backdrop-blur-sm group-hover:bg-brand-accent group-hover:border-brand-accent transition-all duration-300 group-hover:scale-110" data-id="element-106">
                    <PlayIcon className="w-6 h-6 text-brand-white fill-current ml-1" data-id="element-107" />
                  </div>
                </div>
              </div>
              <h4 className="font-display text-xl text-brand-white uppercase tracking-wider mb-1" data-id="element-108">
                {video.title}
              </h4>
              {video.views && <p className="text-brand-muted text-sm uppercase tracking-widest" data-id="element-109">
                  {video.views}
                </p>}
            </Wrapper>;
      })}
      </div>
    </section>;
}